/**
 * Dispatch tab — route-first flow (Feb 2026 v2):
 *   Runs only. Create a delivery run from ANY approved order (packed or
 *   not), see unassigned orders (grouped by date → route), print the
 *   route sheet, and "Pack" per run on a touch-first board.
 *
 * The old Delivery queue sub-tab was retired — delivery scan-and-confirm
 * lives on the PDA now (drivers scan bags at the hotel), and everything
 * dispatcher-facing is unified under Runs.
 */
import DispatchRoutesView from "./dispatch/DispatchRoutesView";

export default function DispatchTab() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-display text-2xl font-bold text-brand-navy tracking-tight">Dispatch</h2>
        <p className="text-sm text-muted-foreground mt-1">
          Plan runs, pack per run, and print route sheets. Drivers scan bags on the PDA.
        </p>
      </div>
      <DispatchRoutesView />
    </div>
  );
}
